import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faUserGroup } from '@fortawesome/pro-light-svg-icons'
import { faUserGroup as faUserGroupSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'

@Component({
    selector: 'fm-people-link',
    imports: [FaIconComponent, RouterModule, CommonModule, TooltipModule],
    templateUrl: './people-link.component.html',
    styleUrl: './people-link.component.scss',
})
export class PeopleLinkComponent {
    public faUserGroup = faUserGroup
    public faUserGroupSolid = faUserGroupSolid
    public isHovered = false
}
